import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropDown_EpidemiologyRate, DropDown_EpidemiologyType, } from '../../../_enum.js';
import { EpidemiologyRate_Percentage, EpidemiologyRate_Ratio, EpidemiologyTypeLabelMap } from '@app/dp-shared';
import { _className, Grid, LL_H_C, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException, exists, ImplementationMissingException } from '@nu-art/ts-common';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { QRangeInputV3 } from '@app/hcs-frontend';
import './Component_EpidemiologyItemEditor.scss';
import { Component_PopulationEditor } from '../Component_PopulationEditor/Component_PopulationEditor.js';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import { ICONS } from '@app/styles';
const ViewMode_View = 'view';
const ViewMode_Edit = 'edit';
export class Component_EpidemiologyItemEditor extends TS_EditableItemComponent {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        state.withRemoveIcon = !!nextProps.withRemoveIcon;
        if (!state.editable.item.type)
            throw new BadImplementationException('Component_EpidemiologyItemEditor does not support rendering Epidemiology item without already existing type');
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? ViewMode_Edit : ViewMode_View;
    composeRate = () => {
        const epidemiology = this.state.editable.item;
        if (!epidemiology.data || !epidemiology.data.rate || !epidemiology.data.rateValue)
            return '';
        //EpidemiologyRate is percentage
        if (epidemiology.data?.rate === EpidemiologyRate_Percentage) {
            if (!exists(epidemiology.data.rateValue[0]) || !exists(epidemiology.data.rateValue[1]))
                return '';
            if (epidemiology.data.rateValue[0] === epidemiology.data.rateValue[1])
                return `${epidemiology.data.rateValue[0]}%`;
            return `${epidemiology.data.rateValue[0]} - ${epidemiology.data.rateValue[1]}%`;
        }
        //EpidemiologyRate is ratio
        if (epidemiology.data.rate === EpidemiologyRate_Ratio) {
            const numerator = epidemiology.data.rateValue.numerator;
            const denominator = epidemiology.data.rateValue.denominator;
            if (!exists(numerator?.[0]) || !exists(numerator?.[1]) || !exists(denominator))
                return '';
            if (numerator[0] === numerator[1])
                return `${numerator[0] ?? 0} / ${denominator ?? 0}`;
            return `${numerator[0] ?? 0} - ${numerator[1] ?? 0} / ${denominator ?? 0}`;
        }
        // @ts-ignore
        throw new ImplementationMissingException(`No composer for epidemiology rate of type ${epidemiology.data.rate}`);
    };
    // ######################## Render ########################
    render() {
        const population = this.state.editable.editProp('population', {});
        const className = _className('epidemiology-item-editor', this.state.editMode && 'edit-mode');
        return _jsxs(Grid, { className: className, children: [this.renderRate(), _jsx(Component_PopulationEditor, { editable: population, editMode: this.state.editMode }), this.state.withRemoveIcon && this.state.editMode && _jsx(ICONS.bin.component, { onClick: () => this.state.editable.delete() })] });
    }
    // ######################## Render - Rate ########################
    renderRate = () => {
        const epidemiology = this.state.editable;
        const data = epidemiology.editProp('data', {});
        return _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                {
                    key: ViewMode_View,
                    renderer: () => _jsx(TS_PropRenderer.Flat, { label: EpidemiologyTypeLabelMap[epidemiology.item.type], children: _jsx("div", { className: 'epidemiology-item-editor__data span-row', children: this.composeRate() }) })
                },
                {
                    key: ViewMode_Edit,
                    renderer: () => _jsxs(_Fragment, { children: [_jsx(DropDown_EpidemiologyType.editable, { editable: epidemiology, prop: 'type' }), _jsx(DropDown_EpidemiologyRate.editable, { editable: data, prop: 'rate', onSelected: rate => {
                                    // @ts-ignore
                                    data.updateObj({ rate, rateValue: undefined });
                                } }), this.renderRateValue()] })
                }
            ] });
    };
    renderRateValue = () => {
        const epidemiology = this.state.editable;
        if (epidemiology.item.data?.rate === EpidemiologyRate_Ratio)
            return this.renderRatioInput();
        return this.renderPercentageInput();
    };
    renderRatioInput = () => {
        const epidemiology = this.state.editable;
        const data = epidemiology.editProp('data', {});
        const rate = data.editProp('rateValue', {});
        return _jsxs(LL_H_C, { className: 'q-range-inputs', children: [_jsx(QRangeInputV3, { editable: rate, prop: 'numerator' }), _jsx("div", { className: 'q-range-inputs__divider', children: "/" }), _jsx(TS_Input, { type: 'number', value: String(rate.item.denominator), onBlur: async (value) => {
                        await rate.updateObj({ denominator: Number(value) });
                    } })] });
    };
    renderPercentageInput = () => {
        const epidemiology = this.state.editable;
        const data = epidemiology.editProp('data', {});
        return _jsxs(LL_H_C, { className: 'epidemiology-item-editor__percentage-input', children: [_jsx(QRangeInputV3, { editable: data, prop: 'rateValue' }), _jsx("div", { className: 'epidemiology-item-editor__percentage-input__icon', children: "%" })] });
    };
}
//# sourceMappingURL=Component_EpidemiologyItemEditor.js.map